import type {
  AuthRepository,
  LoginCredentials,
  PaymentRepository,
  SessionClient,
  UserRepository,
} from "@phurshell/psiapp-frontend-core/domain";
import { LoginError, UserTypes } from "@phurshell/psiapp-frontend-core/domain";

export class Login {
  constructor(
    private readonly authRepo: AuthRepository,
    private readonly sessionClient: SessionClient,
    private readonly paymentRepo: PaymentRepository,
    private readonly userRepo: UserRepository,
  ) {}

  async execute(credentials: LoginCredentials): Promise<void> {
    const { user, access_token } = await this.authRepo.login(credentials);

    if (user.type !== UserTypes.psychologist) {
      throw new LoginError();
    }

    this.sessionClient.saveAuthToken(access_token);

    const cards = await this.paymentRepo.getCreditCards();
    const favorite_card = await this.paymentRepo.getFavoriteCard(
      cards,
      this.sessionClient.getSession()?.favorite_card?.card_id,
    );

    const userData = await this.userRepo.getUserById(user.id);
    this.sessionClient.saveSession({ ...userData, favorite_card });
  }
}
